export const BASIC_INFO_KEY = 'basic-information';
export const LINKS_KEY = 'links';
export const BIO_KEY = 'bio';
export const CONTACT_INFO_KEY = 'contact-information';
export const VERIFY_FACE_ID_KEY = 'verify-face-and-id';
export const ONDATO_APPROVAL = 'ondato-approval';
export const PROFILE_PHOTO_KEY = 'profile-photo';

export const PROFILE_SETUP_FORMS = Object.freeze([
  {
    key: BASIC_INFO_KEY,
    label: 'Basic Information'
  },
  {
    key: LINKS_KEY,
    label: 'Links'
  },
  {
    key: BIO_KEY,
    label: 'Bio'
  },
  // {
  //   key: CONTACT_INFO_KEY,
  //   label: 'Contact Information'
  // },
  {
    key: VERIFY_FACE_ID_KEY,
    label: 'Verify Face & ID'
  }
]);

export const PROFESSIONS = Object.freeze(['Creator', 'Photographer', 'Videographer', 'Producer', 'Podcast', 'Brand']);

export const GENDER = Object.freeze(['Male', 'Female', 'Trans']);

export const PROFILE_SETUP_STEPS = Object.freeze({
  [BASIC_INFO_KEY]: 0,
  [LINKS_KEY]: 1,
  [BIO_KEY]: 2,
  // [CONTACT_INFO_KEY]: 3,
  [VERIFY_FACE_ID_KEY]: 3,
});

export const HEIC_KEY = 'heic';